export default __webpack_public_path__ + "static/media/lsd-rocket.f06e369f.webp";